import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect } from "react";
import MapkitProvider from "./components/common/LazyMapkitProvider";
import { useDispatch } from "react-redux";
import Toast from "./components/common/Toast";
import FirstTimeUserModal from "./components/common/FirstTimeUserModal";
import { AuthContextProvider } from "./features/authentication";
import "./index.css";
import IndexRoutes from "./routes";
import { getCategories } from "./store/thunks/categoryThunk";
import { HelmetProvider } from "react-helmet-async";
import DownloadAppSlider from "./components/common/DownloadAppSlider";
import MobileScrollbar from "./components/common/MobileScrollbar";

const App = () => {
  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(getCategories());
  }, [dispatch]);

  // Bootstrap JS (data-bs-* dropdowns/modals) is not needed for first paint:
  // load it once the browser is idle so it stays out of the startup bundle.
  useEffect(() => {
    const load = () => import("bootstrap/dist/js/bootstrap.bundle.min");
    const id = window.requestIdleCallback
      ? window.requestIdleCallback(load, { timeout: 3000 })
      : setTimeout(load, 1500);
    return () => {
      if (window.cancelIdleCallback && window.requestIdleCallback) window.cancelIdleCallback(id);
      else clearTimeout(id);
    };
  }, []);
  
  return (
    <HelmetProvider>
      <MapkitProvider
        tokenOrCallback={`${process.env.REACT_APP_BACKEND_URL}/v1/apple-mapkit/token`}
      >
        <Toast />
        {/* <FirstTimeUserModal /> */}
        <AuthContextProvider>
          <IndexRoutes />
        </AuthContextProvider>
        <DownloadAppSlider />
        <MobileScrollbar />
      </MapkitProvider>
    </HelmetProvider>
  );
};
export default App;
